(function () {
  'use strict';

  var A = window.DevidAssistantCommerceV5;
  if (!A) return;
  var c = A.copy;

  A.variantSelect = function (product) {
    var select = document.createElement('select');
    var variants = Array.isArray(product.variants) ? product.variants : [];
    select.className = 'devid-assistant-concierge__variant';
    select.setAttribute('data-commerce-v5-variant', '');
    select.setAttribute('aria-label', c.size);
    if (variants.length > 1 || (variants[0] && variants[0].title !== 'Default Title')) {
      var placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = c.size;
      select.appendChild(placeholder);
    }
    variants.forEach(function (variant) {
      var option = document.createElement('option');
      option.value = variant.id;
      option.textContent = !variant.title || variant.title === 'Default Title' ? c.available : variant.title;
      select.appendChild(option);
    });
    if (variants.length === 1 && variants[0].title === 'Default Title') select.value = variants[0].id;
    return select;
  };

  A.selected = function (card) {
    var select = card.querySelector('[data-commerce-v5-variant]');
    return select && select.value ? Number(select.value) : null;
  };

  A.addItems = async function (items, source) {
    var sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
    try {
      var response = await fetch(A.shopRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items, sections: sections.join(','), sections_url: location.pathname })
      });
      var json = {};
      try { json = await response.json(); } catch (error) {}
      if (!response.ok) throw new Error(json.description || json.message || c.error);
      var cartResponse = await fetch(A.shopRoot + 'cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      var cart = await cartResponse.json();
      cart.sections = json.sections || {};
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: { baseEvent: 'variant:add', onSuccessDo: 'force_open_drawer', cart: cart }
      }));
      A.emit('assistant_quick_add', { source: source, item_count: items.length });
    } finally {
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
    }
  };

  A.card = function (product, allowPair) {
    var card = document.createElement('article');
    var media = document.createElement('a');
    var body = document.createElement('div');
    card.className = 'devid-assistant-concierge__product';
    card.setAttribute('data-commerce-v5-card', '');
    media.className = 'devid-assistant-concierge__media';
    media.href = product.url || '#';
    if (product.image) {
      var image = document.createElement('img');
      image.src = product.image;
      image.alt = product.title || '';
      image.loading = 'lazy';
      media.appendChild(image);
    }
    card.appendChild(media);
    body.className = 'devid-assistant-concierge__product-body';
    if (product.vendor) {
      var vendor = document.createElement('p');
      vendor.className = 'devid-assistant-concierge__vendor';
      vendor.textContent = product.vendor;
      body.appendChild(vendor);
    }
    var title = document.createElement('a');
    title.className = 'devid-assistant-concierge__title';
    title.href = product.url || '#';
    title.textContent = product.title || '';
    body.appendChild(title);
    var price = document.createElement('p');
    var strong = document.createElement('strong');
    price.className = 'devid-assistant-concierge__price';
    strong.textContent = product.price || '';
    price.appendChild(strong);
    body.appendChild(price);
    body.appendChild(A.variantSelect(product));

    var actions = document.createElement('div');
    var add = document.createElement('button');
    var view = document.createElement('a');
    actions.className = 'devid-assistant-concierge__actions';
    add.type = 'button';
    add.className = 'devid-assistant-concierge__add';
    add.textContent = c.add;
    view.className = 'devid-assistant-concierge__view';
    view.href = product.url || '#';
    view.textContent = c.view;
    add.addEventListener('click', async function () {
      var variantId = A.selected(card);
      if (!variantId) return;
      add.disabled = true;
      add.textContent = c.adding;
      try {
        await A.addItems([{ id: variantId, quantity: 1, properties: { _assistant_source: 'assistant-commerce-v6' } }], 'single_product');
        add.textContent = c.added;
      } catch (error) {
        add.textContent = c.add;
      } finally {
        add.disabled = false;
        setTimeout(function () { if (add.textContent === c.added) add.textContent = c.add; }, 1800);
      }
    });
    actions.appendChild(add);
    actions.appendChild(view);
    body.appendChild(actions);

    var intent = A.state.intent || A.intent(A.state.request || '', {
      gender: A.state.gender,
      category: A.state.category,
      fit: A.state.fit
    });
    var validPartner = A.partnerOKV6
      ? A.partnerOKV6(product, product.bundle_partner, intent)
      : A.partnerCompatible(product, product.bundle_partner, A.state.gender);
    if (allowPair && validPartner) {
      var pair = document.createElement('button');
      pair.type = 'button';
      pair.className = 'devid-assistant-concierge__add-outfit';
      pair.textContent = c.pair;
      pair.addEventListener('click', function () { A.renderPair(product, c.pairTitle, c.pairText); });
      body.appendChild(pair);
    }
    card.appendChild(body);
    return card;
  };

  A.bundleId = function () {
    return 'assistant-' + Date.now() + '-' + Math.random().toString(36).slice(2, 9);
  };

  A.renderPair = function (base, title, text) {
    var message = A.assistant(title, text);
    var wrapper = document.createElement('div');
    var products = document.createElement('div');
    var baseCard = A.card(base, false);
    var partnerCard = A.card(base.bundle_partner, false);
    var plus = document.createElement('span');
    var button = document.createElement('button');
    var status = document.createElement('p');
    wrapper.className = 'devid-assistant-concierge__outfit';
    products.className = 'devid-assistant-concierge__outfit-products';
    plus.className = 'devid-assistant-concierge__outfit-plus';
    plus.textContent = '+';
    products.appendChild(baseCard);
    products.appendChild(plus);
    products.appendChild(partnerCard);
    wrapper.appendChild(products);
    button.type = 'button';
    button.className = 'devid-assistant-concierge__add-outfit';
    button.textContent = c.addBoth;
    status.className = 'devid-assistant-concierge__outfit-status';
    button.addEventListener('click', async function () {
      var baseVariant = A.selected(baseCard);
      var partnerVariant = A.selected(partnerCard);
      if (!baseVariant || !partnerVariant) {
        status.textContent = c.size;
        return;
      }
      button.disabled = true;
      button.textContent = c.adding;
      var bundleId = A.bundleId();
      try {
        await A.addItems([
          { id: baseVariant, quantity: 1, properties: { _bundle_id: bundleId, _bundle_role: 'primary', _bundle_source: 'assistant-commerce-v6' } },
          { id: partnerVariant, quantity: 1, properties: { _bundle_id: bundleId, _bundle_role: 'partner', _bundle_source: 'assistant-commerce-v6' } }
        ], 'outfit_bundle');
        button.textContent = c.added;
        status.textContent = c.added;
      } catch (error) {
        button.textContent = c.addBoth;
        status.textContent = error.message || c.error;
      } finally {
        button.disabled = false;
      }
    });
    wrapper.appendChild(button);
    wrapper.appendChild(status);
    message.stack.appendChild(wrapper);
    A.scroll();
  };

  A.productRail = function (stack, products) {
    var rail = document.createElement('div');
    rail.className = 'devid-assistant-concierge__rail';
    products.forEach(function (product) { rail.appendChild(A.card(product, true)); });
    stack.appendChild(rail);
  };
})();
